import { useEffect, useMemo, useState } from "react";
import { Search } from "lucide-react";
import { Input } from "@/components/ui/input";

export const PAGE_SIZE = 20;

export function Pager({ page, pages, onPage, testid = "pager" }) {
  if (pages <= 1) return null;
  const from = Math.max(1, Math.min(page - 2, pages - 4));
  const nums = Array.from({ length: Math.min(5, pages) }, (_, i) => from + i);
  const btn = "min-w-8 h-8 px-2 rounded-lg border text-sm transition-colors disabled:opacity-40";
  return (
    <div className="flex flex-wrap items-center justify-center gap-1 py-3" data-testid={testid}>
      <button className={btn} disabled={page === 1} onClick={() => onPage(page - 1)} data-testid={`${testid}-prev`}>‹</button>
      {nums.map((n) => (
        <button key={n} onClick={() => onPage(n)} data-testid={`${testid}-${n}`}
          className={`${btn} ${n === page ? "bg-emerald-700 text-white border-emerald-700" : "bg-white hover:border-emerald-400"}`}>{n}</button>
      ))}
      <button className={btn} disabled={page === pages} onClick={() => onPage(page + 1)} data-testid={`${testid}-next`}>›</button>
      <span className="text-xs text-slate-500 ml-2">{page}/{pages}</span>
    </div>
  );
}

export function SearchBox({ value, onChange, placeholder = "Ara...", testid = "list-search" }) {
  return (
    <div className="relative max-w-xs w-full">
      <Search className="w-4 h-4 absolute left-3 top-2.5 text-slate-400" />
      <Input className="pl-9" data-testid={testid} placeholder={placeholder} value={value} onChange={(e) => onChange(e.target.value)} />
    </div>
  );
}

const flat = (v) => (v == null ? "" : typeof v === "object" ? Object.values(v).map(flat).join(" ") : String(v));

export function usePaged(list, q = "") {
  const [page, setPage] = useState(1);
  const filtered = useMemo(() => {
    const s = q.trim().toLocaleLowerCase("tr");
    return s ? (list || []).filter((x) => flat(x).toLocaleLowerCase("tr").includes(s)) : list || [];
  }, [list, q]);
  const pages = Math.max(1, Math.ceil(filtered.length / PAGE_SIZE));
  useEffect(() => setPage(1), [q]);
  useEffect(() => { if (page > pages) setPage(pages); }, [pages]);
  return { items: filtered.slice((page - 1) * PAGE_SIZE, page * PAGE_SIZE), page, pages, setPage, total: filtered.length };
}
